<template>
  <div class="asc-plot-header">
    <template v-if="isEyeballVisible">
      <div
        :class="[
          'asc-plot-header--icon',
          plotsEyeballsReadonly ? 'asc-plot-header--icon--disabled' : null,
        ]"
      >
        <asc-tooltip :tooltip="visibilityTooltip" right>
          <v-icon
            size="16"
            :disabled="plotsEyeballsReadonly"
            @click="handleToggleVisibility()"
          >
            {{ visibleIcon }}
          </v-icon>
        </asc-tooltip>
      </div>
    </template>

    <div class="asc-plot-header--title">{{ pagePlot.title }}</div>

    <div class="asc-plot-header--close-button">
      <template v-if="isEditPermissionInvestigate && !isPrepopulated">
        <asc-tooltip left tooltip="Remove From Mx Rec" is-icon-tooltip>
          <asc-accent-button
            :on-click="handleDelete"
            button-text="Remove From Mx Rec"
            icon="mdi-close"
            icon-only
            secondary
            custom-class="asc-plot-header--v-btn"
          ></asc-accent-button>
        </asc-tooltip>
      </template>
    </div>
  </div>
</template>

<script>
import AscAccentButton from '@/components/atoms/AscAccentButton'
import AscTooltip from '@/components/atoms/AscTooltip'
import { AscMxRecPermissionMixin } from '@/components/mixins'
export default {
  name: 'AscPlotHeader',

  components: {
    AscAccentButton,
    AscTooltip,
  },
  mixins: [AscMxRecPermissionMixin],

  props: {
    pagePlot: {
      type: Object,
      default: () => {},
    },

    editable: {
      type: Boolean,
      default: false,
    },
    plotsEyeballsVisible: {
      type: Boolean,
      default: false,
    },
    plotsEyeballsReadonly: {
      type: Boolean,
      default: false,
    },
    onDeletePagePlot: {
      type: Function,
      default: () => {},
    },
    onTogglePagePlotVisibility: {
      type: Function,
      default: () => {},
    },
    isPlotUpdating: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isEyeballVisible() {
      // plotsEyeballsVisible is checking for issueinvestigator && !isrecomendationtab || isssueReader
      // isPlotUpdating is checking if plot is updating AscPagePlotWrapper
      // isAnyPrivateFeatureVisible to check if there are any privatefeatures visbile
      // hasAnyPublicFeaturesVisible has any public feature visible
      return (
        this.plotsEyeballsVisible &&
        !this.isPlotUpdating &&
        !this.isAnyPrivateFeatureVisible &&
        this.hasAnyPublicFeaturesVisible
      )
    },

    isPlotEyeballVisible() {
      if (this.pagePlot.isEyeballVisible !== null) {
        return this.pagePlot.isEyeballVisible
      }

      return true
    },

    isAnyPrivateFeatureVisible() {
      if (this.pagePlot.isAnyPrivateFeatureVisible !== null) {
        return this.pagePlot.isAnyPrivateFeatureVisible
      }

      return false
    },

    hasAnyPublicFeaturesVisible() {
      if (this.pagePlot.hasAnyPublicFeaturesVisible !== null) {
        return this.pagePlot.hasAnyPublicFeaturesVisible
      }

      return false
    },

    visibilityTooltip() {
      return !this.plotsEyeballsReadonly
        ? this.pagePlot.plotVisible
          ? 'Hide Plot'
          : 'Show Plot'
        : ''
    },

    visibleIcon() {
      return this.pagePlot.plotVisible ? 'mdi-eye' : 'mdi-eye-off'
    },

    isPrepopulated() {
      const prepopulated = this.pagePlot?.prepopulated || false
      return prepopulated
    },
  },

  methods: {
    handleToggleVisibility() {
      if (this.onTogglePagePlotVisibility && !this.plotsEyeballsReadonly) {
        this.onTogglePagePlotVisibility(
          this.pagePlot.id,
          this.pagePlot.plotTypeId,
          !this.pagePlot.plotVisible,
        )
      }
    },

    handleDelete() {
      if (this.onDeletePagePlot) {
        this.onDeletePagePlot(this.pagePlot.id)
      }
    },
  },
}
</script>

<style lang="scss">
.asc-plot-header {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 34px;
  padding: 2px 8px;

  .asc-plot-header--icon {
    margin: 0 0 0 8px;
    justify-content: center;

    &--disabled {
      cursor: not-allowed;
    }
  }

  &--title {
    flex: 1;
    margin: 0 8px;
  }

  .asc-plot-header--close-button {
    .asc-accent-button-container {
      .asc-accent-button--accent.v-btn--icon.v-size--default {
        min-width: 24px !important;
        max-width: 24px !important;
        height: 28px !important;
      }

      & .asc-plot-header--v-btn {
        border: 0;
        background-color: $gray-200 !important;

        &:hover {
          background-color: $accent-300 !important;
        }
      }
    }
  }

  .mdi-eye-off::before {
    color: $gray-600;
  }

  .mdi-eye {
    &:not(.v-icon--disabled)::before {
      color: $accent-600;
    }
  }

  .v-icon {
    &.v-icon--disabled {
      &::before {
        opacity: 0.6;
        color: $gray-500 !important;
      }
    }
  }
}
</style>
